module.exports = __webpack_public_path__ + "assets/TrByAltitudeBasesDetailed.fb412593667438faaf58ff0036dcd81c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/TrByAltitudeBasesDetailed.png
// module id = 586
// module chunks = 0